<template lang="pug">
.report-page
  .title-section Ventas

  form(@submit.prevent="")
    .input-container.arrow
      select.select(v-model="brand" autocomplete="ño" required)
        option(value="")
        option(v-for="brand in brands" :value="brand") {{ capitalize(brand) }}
      label.label(:class="{ show: brand }") Marca

    sh-date-range-select(default-range="thisMonth" @change="onDateRangeChange")

    .container-actions
      shActionButton(:isForm="true" :action="generateReport" text="Generar Reporte" textRunning="Generando Reporte")

  .container-report
    h3 Resumen
    table.stock-table.table-breakdown
      thead
        tr
          th
          th Unidad
          th Mayorista
          th Total
      tbody
        tr
          td Órdenes
          td {{ totalSales.unit.orders }}
          td {{ totalSales.wholesaler.orders }}
          td {{ totalSales.total.orders }}
        tr
          td Unidades
          td {{ totalSales.unit.quantity }}
          td {{ totalSales.wholesaler.quantity }}
          td {{ totalSales.total.quantity }}
        tr
          td Valor
          td {{ money(totalSales.unit.value) }}
          td {{ money(totalSales.wholesaler.value) }}
          td {{ money(totalSales.total.value) }}
        tr
          td Ticket promedio
          td {{ money(totalSales.unit.valuePerOrder) }}
          td {{ money(totalSales.wholesaler.valuePerOrder) }}
          td {{ money(totalSales.total.valuePerOrder) }}
        tr
          td Venta Diaria
          td {{ money(totalSales.unit.dailyAvgValue) }}
          td {{ money(totalSales.wholesaler.dailyAvgValue) }}
          td {{ money(totalSales.total.dailyAvgValue) }}
        tr
          td Órdenes Diarias
          td {{ totalSales.unit.dailyAvgOrders }}
          td {{ totalSales.wholesaler.dailyAvgOrders }}
          td {{ totalSales.total.dailyAvgOrders }}
        tr
          td Costo Productos
          td {{ money(totalSales.unit.cartCost) }}
          td {{ money(totalSales.wholesaler.cartCost) }}
          td {{ money(totalSales.total.cartCost) }}
        tr
          td Costo de Transporte
          td {{ money(totalSales.unit.deliveryCost) }}
          td {{ money(totalSales.wholesaler.deliveryCost) }}
          td {{ money(totalSales.total.deliveryCost) }}
        tr
          td Transporte cobrado
          td {{ money(totalSales.unit.conveyorCost) }}
          td {{ money(totalSales.wholesaler.conveyorCost) }}
          td {{ money(totalSales.total.conveyorCost) }}
        tr
          td Órdenes con Transporte
          td {{ totalSales.unit.ordersWithConveyor }} ({{ totalSales.unit.conveyorPercent }}%)
          td {{ totalSales.wholesaler.ordersWithConveyor }} ({{ totalSales.wholesaler.conveyorPercent }}%)
          td {{ totalSales.total.ordersWithConveyor }} ({{ totalSales.total.conveyorPercent }}%)

    //- template(v-if="salesByMethodPay.length")
    //-   h3.capitalize Método de Pago
    //-   table.stock-table.table-breakdown
    //-     thead
    //-       tr
    //-         th Método
    //-         th Órdenes
    //-         th Valor
    //-         th %
    //-     tbody
    //-       tr(v-for="item in salesByMethodPay" :key="item.method")
    //-         td.capitalize {{ capitalize(item.method) }}
    //-         td {{ item.orders }}
    //-         td {{ money(item.value) }}
    //-         td {{ item.percent }}%

    h3.capitalize Cambios, Reembolsos y Bonos
    table.stock-table.table-breakdown
      thead
        tr
          th
          th Cambios
          th Reembolsos
          th Bonos
      tbody
        tr
          td Cantidad
          td {{ totalSales.changesCount }}
          td {{ totalSales.refundsCount }}
          td {{ totalSales.bonusesCount }}
        tr
          td Valor
          td {{ money(0) }}
          td {{ money(totalSales.refundsValue) }}
          td {{ money(totalSales.bonusesValue) }}
        tr
          td Valor de transporte
          td {{ money(totalSales.changesCount * 20000) }}
          td {{ money(totalSales.refundsCount * 15000) }}
          td {{ money(totalSales.bonusesCount * 20000) }}

    template(v-if="rotationByArticleDesign.length")
      h3.capitalize Rotación por Artículo-Diseño
      table.stock-table.table-breakdown
        thead
          tr
            th Artículo-Diseño
            th Inv. inicial
            th Inv. final
            th Inv. promedio
            th Vendido
            th Entradas
            th Vendido/día
            th Rotación ({{ reportDays }} días)
            th Cobertura
            th Margen
        tbody
          tr(v-for="item in rotationByArticleDesignTop" :key="item.key")
            td.capitalize {{ item.label }}
            td {{ number(item.initialInventory) }}
            td {{ number(item.finalInventory) }}
            td {{ item.avgInventoryDisplay }}
            td {{ number(item.sold) }}
            td {{ number(item.entries) }}
            td {{ item.dailySalesDisplay }}
            td {{ item.rotationDisplay }}
            td {{ item.coverageDisplay }}
            td {{ item.marginDisplay }}
          template(v-if="showAllRotation")
            tr(v-for="item in rotationByArticleDesignRest" :key="item.key")
              td.capitalize {{ item.label }}
              td {{ number(item.initialInventory) }}
              td {{ number(item.finalInventory) }}
              td {{ item.avgInventoryDisplay }}
              td {{ number(item.sold) }}
              td {{ number(item.entries) }}
              td {{ item.dailySalesDisplay }}
              td {{ item.rotationDisplay }}
              td {{ item.coverageDisplay }}
              td {{ item.marginDisplay }}
      .container-show-all(v-if="rotationByArticleDesignRest.length")
        shActionButton(
          :action="toggleShowAllRotation"
          :text="showAllRotation ? 'Ver menos' : 'Ver todo'"
          :textRunning="showAllRotation ? 'Ver menos' : 'Ver todo'"
          :normalColor="true"
        )

    template(v-if="payUByPlatformUser.length")
      h3 Pagos Automáticos
      table.stock-table.table-breakdown
        thead
          tr
            th Plataforma
            th Propietario
            th Total
        tbody
          tr(v-for="item in payUByPlatformUser" :key="item.key")
            td.capitalize {{ item.platform || '—' }}
            td {{ item.platformUser || '—' }}
            td {{ money(item.total) }}
        tfoot
          tr
            td(colspan="2") Total
            td {{ money(payUTotalValue) }}

    template(v-if="salesByDepartment.length")
      h3.capitalize Ventas por Departamento
      table.stock-table.table-breakdown
        thead
          tr
            th Departamento
            th Órdenes
            th Unidades
            th Valor
            th %
        tbody
          tr(v-for="item in salesByDepartment" :key="item.department")
            td.capitalize {{ capitalize(item.department) }}
            td {{ item.orders }}
            td {{ number(item.quantity) }}
            td {{ money(item.value) }}
            td {{ item.percent }}%
        tfoot
          tr
            td Total
            td {{ totalSales.total.orders }}
            td {{ number(totalSales.total.quantity) }}
            td {{ money(totalSales.total.value) }}
            td 100%
</template>

<script>
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import shDateRangeSelect from '@/components/helpers/DateRangeSelect'

function getReportDays (init, final) {
  if (!init || !final) return 1
  return Math.max(1, Math.round((new Date(final) - new Date(init)) / (1000 * 60 * 60 * 24)) + 1)
}

function formatDecimal (value) {
  return value.toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
}

function formatCoverageDays (days) {
  if (!Number.isFinite(days) || days <= 0) return '—'
  const rounded = Math.min(100, Math.round(days))
  return `${rounded} días`
}

const MIN_INVENTORY_FOR_AVERAGE = 10

function computeGroupDailyAverage (memberStatsList, reportDays) {
  if (!reportDays || !memberStatsList.length) return 0

  let firstDay = reportDays
  memberStatsList.forEach(stats => {
    Object.keys(stats.dailyInventory || {}).forEach(dayKey => {
      const day = Number(dayKey)
      if (Number.isFinite(day) && day < firstDay) firstDay = day
    })
  })

  if (firstDay >= reportDays) return 0

  const lastInventories = memberStatsList.map(() => 0)
  let sum = 0
  let daysCounted = 0

  for (let day = firstDay; day < reportDays; day++) {
    let dayTotal = 0
    memberStatsList.forEach((stats, index) => {
      if (stats.dailyInventory[day] !== undefined) {
        lastInventories[index] = stats.dailyInventory[day]
      }
      dayTotal += lastInventories[index]
    })

    if (dayTotal < MIN_INVENTORY_FOR_AVERAGE) break

    sum += dayTotal
    daysCounted++
  }

  if (!daysCounted) return 0
  return sum / daysCounted
}

function buildRotationRows (statsMap, days) {
  return Object.entries(statsMap)
    .map(([key, stats]) => {
      const avgInventory = stats.avgInventory || 0
      const rotation = avgInventory > 0 ? stats.sold / avgInventory : 0
      const dailySales = stats.sold / days
      const coverageDays = dailySales > 0 ? stats.finalInventory / dailySales : 0
      const margin = stats.revenue > 0 ? ((stats.revenue - stats.cost) / stats.revenue) * 100 : 0

      return {
        key,
        label: stats.label || key,
        sold: stats.sold,
        entries: stats.entries,
        initialInventory: stats.initialInventory,
        finalInventory: stats.finalInventory,
        avgInventory,
        avgInventoryDisplay: formatDecimal(avgInventory),
        rotation,
        rotationDisplay: formatDecimal(rotation),
        dailySales,
        dailySalesDisplay: formatDecimal(dailySales),
        coverageDisplay: formatCoverageDays(coverageDays),
        marginDisplay: `${Math.round(margin)}%`
      }
    })
    .filter(item => item.sold > 0)
    .sort((a, b) => b.dailySales - a.dailySales)
}

export default {
  name: 'ReportSales',

  mixins: [mFilters, mForm],
  components: { shDateRangeSelect },

  data () {
    return {
      init: '',
      final: '',
      brand: '',
      showAllRotation: false
    }
  },

  methods: {
    onDateRangeChange ({ init, final }) {
      this.init = init
      this.final = final
    },
    toggleShowAllRotation () {
      this.showAllRotation = !this.showAllRotation
    },
    async generateReport () {
      this.$store.commit('setInitialDateReport', { report: 'sales', date: this.init })
      this.$store.commit('setFinalDateReport', { report: 'sales', date: this.final })
      this.$store.commit('setBrand', { report: 'sales', brand: this.brand })
      this.showAllRotation = false

      await this.$store.dispatch('getDataSales')
    },
    buildRotationStats () {
      const reportDays = getReportDays(this.init, this.final)
      const reportStart = new Date(this.init)
      reportStart.setHours(0, 0, 0, 0)

      const toDayIndex = (date) => {
        const day = new Date(date)
        day.setHours(0, 0, 0, 0)
        return Math.floor((day - reportStart) / (1000 * 60 * 60 * 24))
      }

      const docs = [...(this.reportSales.docs || [])].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
      const byProduct = {}
      const productMeta = {}
      const byProductSize = {}
      const lastInventoryByProductSize = {}
      const articleDesignMembers = {}

      const ensureStats = (map, key) => {
        if (!map[key]) {
          map[key] = {
            sold: 0,
            entries: 0,
            initialInventory: null,
            finalInventory: 0,
            dailyInventory: {},
            revenue: 0,
            cost: 0
          }
        }
        return map[key]
      }

      const sumInventory = (quantityAvailable) => {
        return (quantityAvailable || []).reduce((sum, qty) => sum + (qty || 0), 0)
      }

      docs.forEach(order => {
        const dayIndex = toDayIndex(order.createdAt)
        const isInReport = dayIndex >= 0 && dayIndex < reportDays

        ;(order.cart || []).forEach(item => {
          const productStats = ensureStats(byProduct, item.product)
          productMeta[item.product] = { article: item.article, design: item.design || '' }
          const inventoryTotal = sumInventory(item.quantityAvailable)
          const soldTotal = item.productQuantity || (item.quantityCart || []).reduce((sum, qty) => sum + (qty || 0), 0)
          const unitPrice = item.appliedPrice || item.priceUnit || 0

          productStats.sold += soldTotal
          productStats.revenue += unitPrice * soldTotal
          productStats.cost += (item.cost || 0) * soldTotal

          if (productStats.initialInventory === null) productStats.initialInventory = inventoryTotal
          productStats.finalInventory = inventoryTotal

          const sizes = item.sizes || []
          const quantityAvailable = item.quantityAvailable || []
          const quantityCart = item.quantityCart || []

          sizes.forEach((size, index) => {
            const sizeKey = `${item.product}:${size}`
            const sizeStats = ensureStats(byProductSize, sizeKey)
            const soldSize = quantityCart[index] || 0
            const inventorySize = quantityAvailable[index] || 0
            const lastInventory = lastInventoryByProductSize[sizeKey]

            if (lastInventory !== undefined) {
              const incoming = inventorySize - lastInventory
              if (incoming > 0) {
                sizeStats.entries += incoming
                productStats.entries += incoming
              }
            }
            lastInventoryByProductSize[sizeKey] = inventorySize - soldSize

            if (isInReport) {
              sizeStats.dailyInventory[dayIndex] = inventorySize - soldSize
            }

            sizeStats.sold += soldSize
            sizeStats.revenue += unitPrice * soldSize
            sizeStats.cost += (item.cost || 0) * soldSize

            if (sizeStats.initialInventory === null) sizeStats.initialInventory = inventorySize
            sizeStats.finalInventory = inventorySize
          })
        })
      })

      const normalizeInventory = (stats) => {
        if (stats.initialInventory === null) stats.initialInventory = 0
      }

      Object.values(byProduct).forEach(normalizeInventory)
      Object.values(byProductSize).forEach(normalizeInventory)

      Object.entries(byProductSize).forEach(([sizeKey, stats]) => {
        const product = sizeKey.split(':')[0]
        const { article, design } = productMeta[product] || {}
        if (!article) return

        const articleDesignKey = `${article}|${design}`
        if (!articleDesignMembers[articleDesignKey]) articleDesignMembers[articleDesignKey] = []
        articleDesignMembers[articleDesignKey].push(stats)
      })

      const byArticleDesign = {}
      Object.entries(byProduct).forEach(([product, stats]) => {
        const { article, design } = productMeta[product] || {}
        if (!article) return
        const key = `${article}|${design}`
        if (!byArticleDesign[key]) {
          byArticleDesign[key] = {
            label: design ? `${article} - ${design}` : article,
            sold: 0,
            entries: 0,
            initialInventory: 0,
            finalInventory: 0,
            revenue: 0,
            cost: 0
          }
        }
        const aggregated = byArticleDesign[key]
        aggregated.sold += stats.sold
        aggregated.entries += stats.entries
        aggregated.revenue += stats.revenue
        aggregated.cost += stats.cost
        aggregated.initialInventory += stats.initialInventory
        aggregated.finalInventory += stats.finalInventory
      })

      Object.keys(byArticleDesign).forEach(key => {
        byArticleDesign[key].avgInventory = computeGroupDailyAverage(articleDesignMembers[key] || [], reportDays)
      })

      return { byArticleDesign }
    }
  },

  computed: {
    reportDays () {
      return getReportDays(this.init, this.final)
    },
    reportSales () {
      return this.$store.state.reports.sales
    },
    brands () {
      return this.$store.state.variables.brands
    },
    totalSales () {
      const emptySegment = () => ({
        orders: 0,
        quantity: 0,
        value: 0,
        cartCost: 0,
        deliveryCost: 0,
        conveyorCost: 0,
        ordersWithConveyor: 0
      })

      const addOrderToSegment = (segment, order) => {
        const cartCost = (order.cart || []).reduce((sum, p) => sum + ((p.cost || 0) * (p.productQuantity || 0)), 0)
        const lastDelivery = (order.deliveries || []).at(-1)
        const deliveryCost = lastDelivery && lastDelivery.status !== 'declined' ? (lastDelivery.cost || 0) : 0
        segment.orders += 1
        segment.quantity += order.quantity || 0
        segment.value += order.total || 0
        segment.cartCost += cartCost
        segment.deliveryCost += deliveryCost
        segment.conveyorCost += order.conveyorCost || 0
        if (order.conveyorCost > 0) segment.ordersWithConveyor += 1
      }

      const finalizeSegment = (segment, days) => {
        segment.valuePerOrder = segment.orders > 0 ? Math.round(segment.value / segment.orders) : 0
        segment.dailyAvgValue = Math.round(segment.value / days)
        segment.dailyAvgOrders = (segment.orders / days).toFixed(1)
        segment.conveyorPercent = segment.orders > 0
          ? ((segment.ordersWithConveyor / segment.orders) * 100).toFixed(1)
          : '0'
        return segment
      }

      const docs = this.reportSales.docs || []
      const totals = docs.reduce((acc, order) => {
        addOrderToSegment(acc.total, order)
        addOrderToSegment(order.isWholesaler ? acc.wholesaler : acc.unit, order)

        const validRefunds = (order.refunds || []).filter(r => r.status === 'approved' || r.status === 'refunded')
        acc.refundsValue += validRefunds.reduce((sum, r) => sum + (r.value || 0), 0)
        acc.refundsCount += validRefunds.length
        acc.changesCount += (order.changes || []).filter(c => ['approved', 'packed', 'sent'].includes(c.status)).length
        const validBonuses = (order.bonuses || []).filter(b => b.status === 'approved')
        acc.bonusesCount += validBonuses.length
        acc.bonusesValue += validBonuses.reduce((sum, b) => sum + (b.originalValue || 0), 0)
        return acc
      }, {
        total: emptySegment(),
        unit: emptySegment(),
        wholesaler: emptySegment(),
        refundsValue: 0,
        refundsCount: 0,
        changesCount: 0,
        bonusesCount: 0,
        bonusesValue: 0
      })

      const total = docs.length
      const days = this.init && this.final
        ? Math.max(1, Math.round((new Date(this.final) - new Date(this.init)) / (1000 * 60 * 60 * 24)) + 1)
        : 1

      finalizeSegment(totals.total, days)
      finalizeSegment(totals.unit, days)
      finalizeSegment(totals.wholesaler, days)

      totals.refundsPercent = total > 0 ? ((totals.refundsCount / total) * 100).toFixed(1) : '0'
      totals.changesPercent = total > 0 ? ((totals.changesCount / total) * 100).toFixed(1) : '0'
      totals.bonusesPercent = total > 0 ? ((totals.bonusesCount / total) * 100).toFixed(1) : '0'
      return totals
    },
    salesByMethodPay () {
      const docs = this.reportSales.docs || []
      const totalValue = docs.reduce((sum, order) => sum + (order.total || 0), 0)
      const byMethod = docs.reduce((acc, order) => {
        const method = order.methodPay || 'desconocido'
        if (!acc[method]) acc[method] = { orders: 0, value: 0 }
        acc[method].orders += 1
        acc[method].value += order.total || 0
        return acc
      }, {})
      return Object.entries(byMethod)
        .map(([method, data]) => ({
          method,
          orders: data.orders,
          value: data.value,
          percent: totalValue > 0 ? ((data.value / totalValue) * 100).toFixed(1) : '0'
        }))
        .sort((a, b) => b.value - a.value)
    },
    salesByDepartment () {
      const docs = this.reportSales.docs || []
      const totalValue = docs.reduce((sum, order) => sum + (order.total || 0), 0)
      const byDepartment = docs.reduce((acc, order) => {
        const department = order.department || 'desconocido'
        if (!acc[department]) acc[department] = { orders: 0, quantity: 0, value: 0 }
        acc[department].orders += 1
        acc[department].quantity += order.quantity || 0
        acc[department].value += order.total || 0
        return acc
      }, {})
      return Object.entries(byDepartment)
        .map(([department, data]) => ({
          department,
          orders: data.orders,
          quantity: data.quantity,
          value: data.value,
          percent: totalValue > 0 ? ((data.value / totalValue) * 100).toFixed(1) : '0'
        }))
        .sort((a, b) => b.value - a.value)
    },
    rotationStats () {
      return this.buildRotationStats()
    },
    rotationByArticleDesign () {
      return buildRotationRows(this.rotationStats.byArticleDesign, this.reportDays)
    },
    rotationByArticleDesignTop () {
      return this.rotationByArticleDesign.slice(0, 10)
    },
    rotationByArticleDesignRest () {
      return this.rotationByArticleDesign.slice(10)
    },
    payUByPlatformUser () {
      const grouped = {}
      ;(this.reportSales.docs || []).forEach(order => {
        ;(order.payU || []).forEach(pay => {
          if ((pay.state || '').toLowerCase() !== 'approved') return
          const platform = pay.platform || '—'
          const platformUser = pay.platformUserName || pay.platformUser || '—'
          const key = `${platform}|${pay.platformUser || '—'}`
          if (!grouped[key]) {
            grouped[key] = { key, platform, platformUser, total: 0 }
          }
          grouped[key].total += pay.value || 0
        })
      })
      return Object.values(grouped).sort((a, b) => b.total - a.total)
    },
    payUTotalValue () {
      return this.payUByPlatformUser.reduce((sum, item) => sum + item.total, 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/reports/Sales.vue